import React from "react";
import { adoptionSteps, included } from "../data/content";
import { Reveal } from "./Reveal";
export function Adoption() {
  return <section id="adoption" className="bg-cream py-24 text-ink lg:py-36" data-id="element-11" data-mp="1meiiv81oj2wq">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10" data-id="element-12" data-mp="1hi1ss8ax6eh0">
        <Reveal className="lg:col-span-5" data-id="element-13" data-mp="1cifdzufg0q63">
          <div className="lg:sticky lg:top-32" data-id="element-14" data-mp="1cjqk40wd2a0d">
            <h2 className="font-display text-4xl leading-[1.05] sm:text-5xl lg:text-6xl" data-id="element-15" data-mp="2a67fh0ljadjh">
              De notre maison <span className="italic text-sage-deep" data-id="element-16" data-mp="256b9wwx6ue1t">à la vôtre.</span>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-ink/70" data-id="element-17" data-mp="20786ti0rqhwh">
              Adopter un Bengal est un engagement de 15 ans. Nous prenons le temps de vous connaître pour que chaque
              chaton rejoigne le foyer qui lui correspond.
            </p>
            <div className="mt-12" data-id="element-18" data-mp="opylsr1zrht2">
              <h3 className="text-sm font-medium" data-id="element-19" data-mp="jsyr1cale1h9">Chaque chaton part avec</h3>
              <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-3 text-sm text-ink/70" data-id="element-20" data-mp="3htf0kwypjdfp">
                {included.map(item => <li key={item} className="border-t border-ink/15 pt-3" data-id="element-21" data-mp="3mrgn5rvcduvx">
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </Reveal>

        <ol className="lg:col-span-6 lg:col-start-7" data-id="element-22" data-mp="3ct0rrcpa7zgm">
          {adoptionSteps.map((step, i) => <Reveal key={step.title} delay={i * 0.04} data-id="element-23" data-mp="2z25iw0es9id1" data-mpi={i}>
              <li className="grid grid-cols-[3.5rem_1fr] gap-4 border-t border-ink/15 py-10 sm:grid-cols-[5rem_1fr]" data-id="element-24" data-mp="33tdriu8agzp5">
                <span className="font-display text-4xl italic text-sage-deep sm:text-5xl" data-id="element-25" data-mp="2p5ix99emun9y">{i + 1}</span>
                <div data-id="element-26" data-mp="2u315exktsygw">
                  <h3 className="font-display text-3xl" data-id="element-27" data-mp="2u4cb52xu0gan">{step.title}</h3>
                  <p className="mt-3 leading-relaxed text-ink/70" data-id="element-28" data-mp="2g3t706whludr">{step.text}</p>
                </div>
              </li>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}